import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Vehicle, vehicleSchema } from '../schemas/vehicle.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Move vehicles from one account to another
 * @param transferRecord All of the information needed to move the vehicle(s)
 * @returns An array of the moved vehicles
 */
export function putVehiclesMove(
  this: unknown,
  transferRecord: {
    sourceAccount: number;
    targetAccount: number;
    vehicles: Vehicle[];
  }
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${fleetEnvironment.resolve(this).vehiclesMoveUrl}`, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(transferRecord),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string().nullable().optional(),
        data: z.array(vehicleSchema),
      })
    )
  );
}
